export default "__VITE_ASSET__50e3a852__"